export default function CriticalError({
  title,
  description,
  action,
}: {
  title?: string;
  description?: string;
  action?: React.ReactNode;
}): React.ReactElement {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="font-bold mb-4">{title || "Unexpected error"}</h1>
      <p>{description || "An unexpected error occurred."}</p>
      {action}
    </div>
  );
}
